export default (filterToggleId, filterBlock) => {
  let isMobile = false
  if( window.innerWidth < 992 ) {
    isMobile = true
  }

  if( isMobile ) {
    const filterToggleElement = document.getElementById(filterToggleId)
    if (!filterToggleElement) {
      return
    }

    const filterBlockElement = document.getElementById(filterBlock)
    if (!filterBlockElement) {
      return
    }

    filterToggleElement.addEventListener('click', (event) => {
      filterBlockElement.classList.toggle('visible')
      filterToggleElement.classList.toggle('active')
    })
  }

}

